//#region src/string/escape-html.ts
function escapeHtml(str) {
	return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/`/g, "&#96;");
}
//#endregion
export { escapeHtml };

//# sourceMappingURL=escape-html.js.map